module.exports = __webpack_public_path__ + "static/media/bong.c0648296.svg";